export const Address1 = "9634 Port Sheldon St"
export const Address2 = "Zeeland, MI 49464"

export const Name = "Ken Kuipers & Angela Fox"
export const Phone = "(616) 836-3430"
export const Email = "angela@deltaproducts-corp.com"